import React, { useEffect, useState, useContext, useRef } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import * as XLSX from "xlsx";
import "./Uploadfile.scss";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Row, Col } from "react-bootstrap";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import axiosInstance from "../../ReusableComponents/Axios";
import { RiDownload2Fill } from "react-icons/ri";
import notify from "../../ReusableComponents/ToastifyAlerts";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { useSelector } from "react-redux";
import { IoCloseCircleOutline } from "react-icons/io5";
const OMRUPloadfile = () => {
  const inputRef = useRef();
  const { SetLoad, Load } = useContext(LoadContext);

  const [data, setData] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  const [fileName, setFileName] = useState("");
  const [EXDetails, SetEXDetails] = useState([]);
  const [FSubmition, SetFSubmition] = useState(false);
  const [DOMR, SetDOMR] = useState();
  const [UPloadExit, SetUPloadExit] = useState(false);
  const [GradeSet, SetGradeSet] = useState();
  const [ResCount, SetResCount] = useState();
  const [TesTypes, SetTesTypes] = useState([]);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const allowedTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const validateFile = (file) => {
    return allowedTypes.includes(file.type);
  };

  const excelSerialToDate = (serial) => {
    const parsed = XLSX.SSF.parse_date_code(serial);
    if (!parsed) return serial;
    const { y, m, d } = parsed;
    return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  };

  const handleFileUpload = (e, DF) => {
    const file = DF === "DragFile" ? e : e.target.files[0];
    const TTName = TesTypes.find((item) => item.value === file.name.split("_")[0])?.display;
    if (file.name.split("_").length < 3 && TTName === undefined) {
      // setData([]);
      setDragActive(false);
      setFileName("");
      inputRef.current.value = null;
      return notify("File name format is incorrect. Please follow the format: AssessmentTypeName_SchoolId_Year", "error");
    }
    GetDetailsOFOMR(file.name.split("_")[0], file.name.split("_")[1]);
    if (DF !== "DragFile") {
      setFileName(e.target.files[0].name);
    }
    if (!file) return;
    SetLoad((prev) => !prev);
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, {
        type: "binary",
        cellDates: false, // Excel serial numbers come as numbers
      });

      let finalData = [];
      let gradeSet = new Set();
      workbook.SheetNames.forEach((sheetName) => {
        const grade = sheetName.split(" ")[1];
        gradeSet.add(grade);
        const ws = workbook.Sheets[sheetName];

        let rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const headers = rows[1];
        const dataRows = rows.slice(2);
        const formatted = dataRows.map((row) => {
          const obj = {};

          headers.forEach((header, index) => {
            if (!header) return;

            let value = row[index];
            if (
              typeof value === "number" &&
              header.toLowerCase().includes("date")
            ) {
              value = excelSerialToDate(value);
            }

            obj[header] = value ?? null;
          });
          return {
            Grade: sheetName.split(" ")[1],
            // PaperCode: obj["PaperCode"],
          ...(obj["PaperCode"] && {
    PaperCode: obj["PaperCode"],
  }),
            StudentId: obj["Student Id"]?.toString(),
            // AttendedDate: obj["Attended Date time"],
            AssessmentTypeName: file.name.split("_")[0],
            SchoolId: file.name.split("_")[1],
            StudentResponses: Object.fromEntries(
              Object.entries(obj).filter(
                ([key]) => key !== "Student Id" && key !== "Attended Date time"
              )
            ),
          };
        });

        finalData.push(...formatted);
      });
      // SetGradeSet([...gradeSet]);
      setData(finalData);

      // const findDetails = EXDetails.filter(
      //   (details) =>
      //     details?.schoolId === file.name.split("_")[1] &&
      //     details?.assessmentTypeName == file.name.split("_")[0]
      // );
      // SetUPloadExit(findDetails?.length > 0 && true);
      // {
      //     GradeSet?.map((grade) => (
      //         <>
      //             <span>Grade {grade} : {data.filter((SGrade) => SGrade?.Grade === grade)?.length} </span>
      //         </>
      //     ))
      // }
      const GCOunt = [...gradeSet]?.map((Grade) => ({
        Grade: Grade,
        GradeCount: finalData.filter((SGrade) => SGrade?.Grade == Grade)
          ?.length,
      }));
      SetGradeSet(GCOunt);

      SetLoad((prev) => !prev);
    };

    reader.readAsBinaryString(file);
  };
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    else if (e.type === "dragleave") setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      if (validateFile(file)) {
        setFileName(file.name);
        handleFileUpload(file, "DragFile");
      } else {
        notify("Only Excel files (.xlsx, .xls) are allowed!", "warning");
      }
    }
  };

  const PostFIledata = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.post(
        `${data?.[0]?.PaperCode ? "/NCLAdmin/OMRUploadStudentResponses" : "/NCLAdmin/OMRUploadStudentResponses_NoPaperCode"}    `,
        data
      );
      // switch (res.data) {
      //   case 1:
      //     notify( "OMR based Student Responses uploaded successfully.", "success" );
      //     break;
      //   case 0:
      //     notify( "OMR based Student Responses not uploaded - Please try again", "error" );
      //     break;
      //   case -1:
      //     notify("The uploded file alredy exists", "warning");
      //     break;
      // }
      setData([]);
      setDragActive(false);
      // setFileName("");
      inputRef.current.value = null;
      SetFSubmition(false);
      GetPreviousDetails();
      if(res.data?.validCount > 0 || res.data?.invalidCount > 0){
        SetResCount(res.data);
      }else{
          setData([]); setDragActive(false);
                    setFileName(""); inputRef.current.value = null;
        notify(res.data?.message, "warning");
      }
      SetLoad((prev) => !prev);
    } catch (err) {
      console.log(err);
    }
  };
  const DownloadSamplefile = () => {
    const a = document.createElement("a");
    // a.style.display = 'none';
    a.href = "/StudentResponses.xlsx";
    a.download = "AssessmentTypeName_SchoolId_OMRResponses.xls";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const GetPreviousDetails = async () => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetOMRAssessmentDetails`);
      if (res.data.length > 0) {
        SetEXDetails(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetPreviousDetails();
    GeTesTypes();
  }, []);
  const GeTesTypes = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=73&ParentLovId=0&LanguageId=0`
      );
      const FormatedOptions = res.data.map((item) => ({
        display: item.lovDescription,
        value: item.lovId,
      }));
      SetTesTypes(FormatedOptions);
    } catch (err) {
      console.log(err);
    }
  };
  const OMRColumns = [
    { name: "Assessment Name", selector: "assessmentTypeName", sortable: true },
    { name: "Assessment Date", selector: "assessmentStartDate", sortable: true, },
    { name: "Institute Name", selector: "institute", sortable: true },
    { name: "School", selector: "schoolName", sortable: true },
    { name: "Grades", selector: "grades", sortable: true },
    { name: "Date Uploaded", selector: "uploadedDate", sortable: true },
    { name: "OMR Responses Uploaded", selector: "noOfResponsesUploaded", sortable: true },
  ];

  const GetDetailsOFOMR = async (ANAME, SID) => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetSchoolAndAssessmentInformationForOMR?SchoolId=${SID}&AssessmentTypeName=${ANAME}`
      );
      SetDOMR(res.data[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const DownloadFIle = () => {

    // Convert Base64 to binary string
    const byteCharacters = atob(ResCount.fileContent);

    // Convert binary string to byte array
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create Blob
    const blob = new Blob(
      [byteArray],
      { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
    );

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${fileName.split(".")[0]}_FailedRecords.xlsx`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    notify("Invalid responses data downloaded successfully.", "warning");
    SetResCount();
    setFileName("");
  }

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex alignitems JSBetween  mb-3">
          <div></div>
          <div
            className="MainHeading"
            style={{ position: "relative", left: "11vw" }}
          >
            Import OMR Responses
          </div>
          <div
            className="dflex alignitems Temp-Buttons CPointer"
            onClick={DownloadSamplefile}
          >
            <RiDownload2Fill />
            Click here to download the template
          </div>
        </div>
        <div className="container-fluid">
          <Row>
            <Col>
              <div className="">
                <input
                  type="file"
                  onChange={handleFileUpload}
                  ref={inputRef}
                  accept=".xlsx, .xls"
                  hidden
                />
                <div
                  onClick={() => inputRef.current.click()}
                  className={`dropzone ${dragActive ? "active" : ""} CPointer`}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                >
                  {fileName ? (
                    <p className="file-name">{fileName}</p>
                  ) : (
                    <>
                      <FaCloudUploadAlt fontSize={32} />
                      <p> Drag and Drop your file here </p>
                      <p> or </p>
                      <button className="Buttons">Browse file</button>
                    </>
                  )}
                </div>
              </div>
            </Col>
            <Col>
              <div className="SubHeading mb-2">
                Instructions for Importing responses :
              </div>
              <ol>
                <li>
                  The format of the Assessment file name should be
                  AssessmentTypeName_SchoolId_Year. For example,
                  SODHANA1_134065_2026-27
                </li>
                <li>
                  Student responses values should be any of the following values
                  - A,B,C,D
                </li>
                <li>Only the files of type 'xlsx' or 'xls' are allowed.</li>
                <li>
                  Once the file is selected for upload, click on 'Review and
                  Submit' to save the student responses data.
                </li>
                <li>
                  The assessment responses once submitted for a school are not
                  allowed to resubmit again for the same school.
                </li>
                <li>Paper Code should be any of the values - 1,2,3,4</li>
              </ol>
            </Col>
          </Row>
        </div>

        {fileName && (
          <div className=" InputFIlters mt-5">
            <label>
              Please check the below details and click "Review and Submit" to
              upload
            </label>
            <div className="Card dflex JSBetween alignitems gap-3">
              <div
                className="gap-3"
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto auto auto",
                }}
              >
                <span>
                  <b>School Id :</b> {fileName?.split("_")[1]}{" "}
                </span>
                <span>
                  {" "}
                  <b>Assessment Name :</b>{" "}
                  {fileName?.split("_")[0]?.toUpperCase()}
                </span>
                <span>
                  {" "}
                  <b>Acadamic Year :</b> {USYear?.display}{" "}
                </span>
                <span>
                  {" "}
                  <b>Institute / Society :</b>
                  {DOMR?.instituteId === 8 || DOMR?.instituteId === 9
                    ? DOMR?.societyName
                    : DOMR?.instituteName}
                </span>
                <span>
                  {" "}
                  <b>Assessment Date :</b> {DOMR?.examStartDate}
                </span>
                <span>
                  {" "}
                  <b>School Name :</b> {DOMR?.schoolName}
                </span>
              </div>
              <div className="NCLDataTable mb-2">
                <table className="Data-Table">
                  <tr>
                    <th
                      style={{
                        backgroundColor: "rgba(28, 162, 122, 0.4392156863)",
                      }}
                    >
                      Grade
                    </th>
                    {GradeSet?.map((Grade) => (
                      <td className="p-2">{Grade?.Grade}</td>
                    ))}
                  </tr>
                  <tbody>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "rgba(28, 162, 122, 0.4392156863)",
                        }}
                      >
                        Students Count
                      </th>
                      {GradeSet?.map((Grade) => (
                        <td className="p-2">{Grade?.GradeCount}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="dflex gap-2 JSBetween"
              >
                <button
                  className={`Buttons ${!fileName && "DisableButton"}`}
                  disabled={!fileName}
                  onClick={() => SetFSubmition(!FSubmition)}
                > Review and Submit </button>
                <button
                  className="CancleButton Buttons"
                  onClick={() => {
                    setData([]);
                    setDragActive(false);
                    setFileName("");
                    inputRef.current.value = null;
                    // SetEXDetails([]);
                  }}
                >Cancel </button>
              </div>
            </div>
          </div>
        )}

        <div className="SubHeading mt-3"> OMR logs </div>
        <DataTable data={EXDetails} className="NCLDataTable Card mt-2" columns={OMRColumns} />
        {/* <pre style={{ background: "#f4f4f4", padding: 12, marginTop: 20 }}>
                    {JSON.stringify(data, null, 2)} </pre> */}
        {FSubmition && (
          <div className="Model-Open">
            <div className="Card w-50 Model-Content">
              <div className="mt-3">
                <p>
                  {" "}
                  {UPloadExit
                    ? "The responses for the assessment type and the provided school were already uploaded. Please check the details."
                    : "The responses once submitted cannot be reverted. Please make sure that the details are correct, and click Confirm to Proceed or 'Cancel' to cancel the upload. "}
                </p>
                <div className=" dflex gap-4" style={{ justifyContent: "end" }}>
                  {!UPloadExit && (
                    <button className="Buttons" onClick={() => PostFIledata()}> Confirm </button>
                  )}
                  <button className="Buttons CancleButton"
                    onClick={() => SetFSubmition(false)} > Cancel </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {ResCount &&
        <div className="Model-Open">
          <div className=" Card Model-Content p-4"
            style={{ color: "white", textAlign: "center", }} >
            {/* Close button */}
            {ResCount?.invalidCount === 0 && (
              <div className="dflex JSBetween">
                <div></div>
                <IoCloseCircleOutline size={24} className="CPointer" style={{color:"black"}}
                  onClick={() => {
                    SetResCount();
                    setData([]); setDragActive(false);
                    setFileName(""); inputRef.current.value = null;
                  }}
                />
              </div>
            )}

            {/* Success Icon */}
            <div className="dflex alignitems JCCenter m-auto OMRTick" > ✓ </div>

            {/* Title */}
            <div className="mt-3 mb-3 SubHeading" style={{ color: "black" }}> OMR Responses Processed Successfully </div>

            {/* Statistics */}
            <div className="dflex JSBetween gap-2" style={{ color: "white" }}>

              <div className="p-3 Filedetails"
                style={{ background: "linear-gradient(135deg,#3498db,#2980b9)" }} >
                <b style={{ fontSize: "24px" }}> {ResCount?.validCount + ResCount?.invalidCount} </b>
                <div >Total</div>
              </div>

              <div className="p-3 Filedetails"
                style={{ background: "linear-gradient(135deg,#2ecc71,#27ae60)" }} >
                <b style={{ fontSize: "24px" }}> {ResCount?.validCount} </b>
                <div >Uploaded</div>
              </div>

              <div className="p-3 Filedetails"
                style={{ background: "linear-gradient(135deg,#e74c3c,#c0392b)" }} >
                <b style={{ fontSize: "24px" }}> {ResCount?.invalidCount} </b>
                <div >Invalid</div>
              </div>

            </div>

            {/* Download Button */}
            {ResCount?.invalidCount > 0 && (
              <button className="Buttons mt-3 w-100 p-3"
                style={{
                  fontWeight: "600",
                  background: "linear-gradient(135deg,#16a085,#1abc9c)",
                }}
                onClick={() => DownloadFIle()} >
                <RiDownload2Fill /> Download Invalid Responses </button>
            )}
          </div>
        </div>}
    </>
  );
};
export default OMRUPloadfile;